import { Component, EventEmitter, Input, Output, Signal } from '@angular/core';
import { DatepickerDirective } from '../../../shared/directives';
import { FormsModule } from '@angular/forms';
import  { SelectDropDownModule } from 'ngx-select-dropdown';
import { FilterFieldMap } from '../../../core/models';

@Component({
  selector: 'app-filter-bar',
  imports: [
    DatepickerDirective, 
    FormsModule, 
    SelectDropDownModule
  ],
  templateUrl: './filter-bar.component.html',
  styleUrl: './filter-bar.component.scss'
})
export class FilterBarComponent{
  @Input() filterFieldMap!: Signal<FilterFieldMap>;
  @Output() filtersChanged = new EventEmitter<FilterFieldMap>();
  

 emitFilters(){
    this.filtersChanged.emit(this.filterFieldMap());
  }

  get filterFieldArray() {
    return Object.values(this.filterFieldMap());
  }

  configSelectSearch = {
    displayKey: "name",
    search: true,
    height: '200px',
    placeholder: 'Seleziona un\'opzione',
    moreText: 'altre',
    noResultsFound: 'Nessun risultato trovato!',
    searchPlaceholder: 'Cerca...',
    selectAllLabel: 'Seleziona tutto',
    enableSelectAll: true,
    limitTo: 5,
    searchOnKey: 'name',
  };

}
